export const GeneralFilters = [
  { text: 'anniversary prize payment', value: 'anniversary_prize_payment' },
  {
    text: 'bonus111 profit withdrawal',
    value: 'bonus111_profit_withdrawal',
  },
  { text: 'bonus111 transfer', value: 'bonus111_transfer' },
  {
    text: 'bonus150 profit withdrawal',
    value: 'bonus150_profit_withdrawal',
  },
  { text: 'cashbooster reward', value: 'cashbooster_reward' },
  { text: 'client cashback', value: 'client_cashback' },
  { text: 'client commission', value: 'client_commission' },
  {
    text: 'copytrade investor payment',
    value: 'copy_trade_investor_payment',
  },
  {
    text: 'copytrade trader payment',
    value: 'copy_trade_trader_payment',
  },
  { text: 'demo contests payment', value: 'demo_contests_payment' },
  { text: 'deposit', value: 'deposit' },
  { text: 'deposit bonus', value: 'deposit_bonus' },
  {
    text: 'deposit bonus adjustment',
    value: 'deposit_bonus_adjustment',
  },
  {
    text: 'deposit bonus balance fall',
    value: 'deposit_bonus_balance_fall',
  },
  { text: 'deposit bonus cut', value: 'deposit_bonus_cut' },
  { text: 'deposit bonus reward', value: 'deposit_bonus_reward' },
  { text: 'dividend accrual', value: 'dividend_accrued' },
  { text: 'dividend withdrawal', value: 'dividend_withdrawal' },
  { text: 'exchanger transfer', value: 'exchanger_transfer' },
  {
    text: 'giftshop crowns exchange deposit',
    value: 'giftshop_crowns_exchange_deposit',
  },
  { text: 'golden may 2025 reward', value: 'golden_may_2025_reward' },
  { text: 'golden may 2026 reward', value: 'golden_may_2026_reward' },
  {
    text: 'ib client cashback deposit',
    value: 'ib_client_cashback_deposit',
  },
  {
    text: 'ib partner rebate withdrawal',
    value: 'ib_partner_rebate_withdrawal',
  },
  { text: 'internal resale buy', value: 'internal_resale_buy' },
  { text: 'internal resale sell', value: 'internal_resale_sell' },
  { text: 'internal sale', value: 'internal_sale' },
  { text: 'internal transfer', value: 'internal_transfer' },
  { text: 'manual', value: 'manual' },
  { text: 'new year 2026 reward', value: 'new_year_2026_reward' },
  { text: 'nova deposit', value: 'nova_deposit' },
  { text: 'nova sale', value: 'nova_sale' },
  { text: 'nova withdrawal', value: 'nova_withdrawal' },
  { text: 'partner commission', value: 'partner_commission' },
  { text: 'ramadan2025', value: 'ramadan2025' },
  { text: 'transaction', value: 'transaction' },
  { text: 'withdrawal', value: 'withdrawal' },
  { text: 'Worldcup 2026 reward', value: 'worldcup_2026_reward' },
]

export const NovaFilters = [
  { text: 'deposit', value: 'deposit' },
  { text: 'dividend withdrawal', value: 'dividend_withdrawal' },
  { text: 'dividend accrued', value: 'dividend_accrued' },
  { text: 'nova sale', value: 'nova_sale' },
  { text: 'nova deposit', value: 'nova_deposit' },
  { text: 'nova withdrawal', value: 'nova_withdrawal' },
  { text: 'internal resale sell', value: 'internal_resale_sell' },
  { text: 'internal resale buy', value: 'internal_resale_buy' },
  { text: 'internal sale', value: 'internal_sale' },
]
